import React from 'react';
import {TrashIcon} from '../../icons';
import {Tooltip} from 'react-tooltip';
import {useTranslation} from '../../../../hooks/useTranslation';

function RemoveButton({handleRemove, idx, id}) {
  const {t} = useTranslation();
  
  return (
    <div
      className='f-build__fd_trash'
      onClick={handleRemove}
      data-tooltip-id={`${id}-remove-${idx}`}
      data-tooltip-content={t('createNewForm.components.removeField')}
    >
      <TrashIcon />
      <Tooltip id={`${id}-remove-${idx}`} place={'bottom-end'} />
    </div>
  );
}

export default RemoveButton;
